import React from "react";
import CookieConsent from "react-cookie-consent";
import { useTranslation } from "react-i18next";
import { Box, Link, Typography } from "@mui/material";
import theme from "../../theme/theme";

const CookieConsentBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <CookieConsent
      location="bottom"
      buttonText={t("cookieConsent.button")}
      cookieName="beapolo-cookie-consent"
      style={{
        background: theme.palette.primary.main,

        padding: "10px 20px",
        alignItems: "center",
        zIndex: 9999,
      }}
      buttonStyle={{
        background: theme.palette.secondary.main,
        color: theme.palette.primary.main,
        fontSize: "16px",

        fontWeight: 700,
        borderRadius: "50px",
        padding: "8px 25px",
      }}
      expires={365}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography
          variant="pMedium"
          sx={{
            color: theme.palette.neutral.main,
          }}
        >
          {t("cookieConsent.message")}
        </Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Link
            href="/privacy-policy"
            sx={{
              color: theme.palette.secondary.main,
              textDecoration: "underline",

              fontSize: "14px",
              marginRight: "10px",
            }}
          >
            {t("cookieConsent.privacyPolicy")}
          </Link>
          <Link
            href="/terms-and-conditions"
            sx={{
              color: theme.palette.secondary.main,
              textDecoration: "underline",

              fontSize: "14px",
            }}
          >
            {t("legal.termsAndConditions.title")}
          </Link>
          <Link
            href="/legal-notice"
            sx={{
              color: theme.palette.secondary.main,
              textDecoration: "underline",

              fontSize: "14px",
            }}
          >
            {t("legal.legalNotice.title")}
          </Link>
          <Link
            href="/cookie-policy"
            sx={{
              color: theme.palette.secondary.main,
              textDecoration: "underline",

              fontSize: "14px",
            }}
          >
            {t("legal.cookiePolicy.title")}
          </Link>
        </Box>
      </Box>
    </CookieConsent>
  );
};

export default CookieConsentBanner;
